type Entries<T> = {
  [K in keyof T]: [K, T[K]];
}[keyof T][];

export function entries<T extends object>(o: T) {
  return Object.entries(o) as Entries<T>;
}

export function keys<T extends object>(o: T) {
  return Object.keys(o) as Entries<T>[0];
}

export function values<T extends object>(o: T) {
  return Object.values(o) as Entries<T>[1];
}

/**
 * 대상 객체가 비어 있는지 확인해 반환한다.
 *
 * @param object 대상 객체.
 * @param includeNullity `true`인 경우 값이 `null`이나 `undefined`인 경우도 비어 있는 것으로 본다.
 */
export function isEmpty(object: any, includeNullity?: boolean): boolean {
  return (
    !object ||
    (includeNullity
      ? Object.keys(object).filter((key) => object[key] !== null && object[key] !== undefined)
          .length === 0
      : Object.keys(object).length === 0)
  );
}
